/**
 * Cross-window wiring for the popped-out Coach (/coach).
 *
 * One BroadcastChannel, two message types:
 *   { type: 'screen', path, search }  — the MAIN app window broadcasts its
 *       current route whenever it changes, so a popped-out Coach stays
 *       screen-aware ("I see you're on Reconciliation") even though it lives
 *       in its own window.
 *   { type: 'navigate', route }       — the POP-OUT posts this when the user
 *       clicks a "Take me there" button; the main window navigates. Coach on
 *       monitor two literally drives the app on monitor one.
 *
 * BroadcastChannel never delivers a message back to the context that posted
 * it, so the two instances can share one channel without echo. Browsers
 * without BroadcastChannel (none we support, but belt-and-braces) just get
 * a popped-out Coach that navigates its own window.
 */
const CHANNEL_NAME = 'kodahfy-coach';

export const createCoachChannel = () => {
  if (typeof window === 'undefined' || !('BroadcastChannel' in window)) return null;
  try { return new BroadcastChannel(CHANNEL_NAME); } catch { return null; }
};

export const COACH_POPOUT_FEATURES = 'width=480,height=860,menubar=no,toolbar=no,location=no,status=no';
